// Check-in API. Mirrors the server `user-check-in` module response shapes.

import { axiosInstance } from 'src/api';
import formatError from 'src/api/utils/format-error';

export type CheckInStatus = 'completed' | 'skipped';

export interface CheckInStatusResponse {
  totalActivitiesCompleted: number;
  // Check-in numbers already completed or skipped by the user.
  recordedNumbers: number[];
  // The milestone check-in the user has reached but not yet recorded, or null.
  dueCheckInNumber: number | null;
}

export interface RecordCheckInPayload {
  checkInNumber: number;
  status: CheckInStatus;
}

export interface CheckInRecord {
  id: string;
  checkInNumber: number;
  status: CheckInStatus;
  submittedAt: string;
}

/** GET /api/check-ins — activity count + which milestone check-in is due, if any. */
export async function getCheckInStatus(): Promise<CheckInStatusResponse> {
  try {
    const { data } = await axiosInstance.get<CheckInStatusResponse>('/check-ins');
    return data;
  } catch (error) {
    throw formatError(error);
  }
}

/** POST /api/check-ins — mark a check-in as completed or skipped. */
export async function recordCheckIn(payload: RecordCheckInPayload): Promise<CheckInRecord> {
  try {
    const { data } = await axiosInstance.post<{ checkIn: CheckInRecord }>('/check-ins', payload);
    return data.checkIn;
  } catch (error) {
    throw formatError(error);
  }
}
